/**
 * dir-w | backOffice
 * Stand alone footer partial component, used at
 * - Forgot Password
 * - Sign In
 * - Sign Up
 * - Verify Email Resend
 *
 * Last update : June 8, 2024 | @rizkiprasetya
 */

import { Component } from '@angular/core';
import { Configuration } from '../../../config/configuration';

@Component({
    selector: 'app-stand-alone-footer',
    templateUrl: './stand-alone-footer.component.html',
    styleUrl: './stand-alone-footer.component.css',
    standalone: false
})
export class StandAloneFooterComponent {
  protected configuration = Configuration;
}
